import httpClient from "http-client/http-client";

const base = (communityId) =>
  `v1/community-portal/community/${encodeURIComponent(communityId)}`;

export async function getMembershipOffering(communityId) {
  const { data, errors } = await httpClient.get({
    url: `${base(communityId)}/membership-offering`,
  });
  if (errors?.length) return { data: null, errors };
  return { data };
}

export async function createTier(communityId, body) {
  const { data, errors } = await httpClient.post({
    url: `${base(communityId)}/tiers`,
    body,
  });
  if (errors?.length) return { data: null, errors };
  return { data };
}

export async function updateTier(communityId, tierId, body) {
  const { data, errors } = await httpClient.patch({
    url: `${base(communityId)}/tiers/${encodeURIComponent(tierId)}`,
    body,
  });
  if (errors?.length) return { data: null, errors };
  return { data };
}

export async function deleteTier(communityId, tierId) {
  const { data, errors } = await httpClient.delete({
    url: `${base(communityId)}/tiers/${encodeURIComponent(tierId)}`,
  });
  if (errors?.length) return { data: null, errors };
  return { data };
}

export async function createPlan(communityId, tierId, body) {
  const { data, errors } = await httpClient.post({
    url: `${base(communityId)}/tiers/${encodeURIComponent(tierId)}/plans`,
    body,
  });
  if (errors?.length) return { data: null, errors };
  return { data };
}

export async function updatePlan(communityId, tierId, planId, body) {
  const { data, errors } = await httpClient.patch({
    url: `${base(communityId)}/tiers/${encodeURIComponent(tierId)}/plans/${encodeURIComponent(planId)}`,
    body,
  });
  if (errors?.length) return { data: null, errors };
  return { data };
}

export async function deletePlan(communityId, tierId, planId) {
  const { data, errors } = await httpClient.delete({
    url: `${base(communityId)}/tiers/${encodeURIComponent(tierId)}/plans/${encodeURIComponent(planId)}`,
  });
  if (errors?.length) return { data: null, errors };
  return { data };
}

export async function fetchMembers(
  communityId,
  { current_page = 1, page_size = 20, ...filters } = {}
) {
  const { data, errors } = await httpClient.post({
    url: `${base(communityId)}/members/fetch`,
    body: { current_page, page_size, ...filters },
  });
  if (errors?.length) return { data: null, errors };
  return { data };
}
